import { BusinessType } from "@reef-os/utils/enums/businessType"

let locationNameFormatterMixin = {
    filters: {
        locationName(businessType) {
            switch (businessType) {
                case BusinessType.BAR: {
                    return "Table"
                }
                case BusinessType.HOTEL: {
                    return "Room"
                }
                case BusinessType.RESIDENTIAL: {
                    return "Apt"
                }
                case BusinessType.COWORKING: {
                    return "Suite"
                }
                case BusinessType.AIRPORT: {
                    return "Gate"
                }
            }
            return ""
        }
    }
}

export default locationNameFormatterMixin